module.exports = __webpack_public_path__ + "officialStatic/img/aboutUs.17914b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/aboutUs.jpg
// module id = Tphl
// module chunks = 0